import { useMemo } from 'react';

import { getMsUntilNextSecond } from '#shared';

import { usePollingQuery } from '../../usePollingQuery';
import { useGetSurgeonsQuery } from '../surgeons.api';
import { useStaleWhileEmpty } from '../useStaleWhileEmpty';

import type { CCSurgeon } from '#entities';
import type { PollingQueryResult } from '../types';

const TARGET_SECOND = 5;

const getSurgeonsDelay = () => getMsUntilNextSecond(TARGET_SECOND);

export const useQuerySurgeons = (): PollingQueryResult<CCSurgeon[]> => {
  const queryResult = useGetSurgeonsQuery(undefined, {
    pollingInterval: 0,
  });

  const pollingResult = usePollingQuery(queryResult, {
    getDelay: getSurgeonsDelay,
  });

  const stale = useStaleWhileEmpty(
    {
      data: pollingResult.data?.data ?? [],
      generatedAt: pollingResult.data?.generatedAt ?? null,
    },
    pollingResult.lastReceiveTime?.getTime() ?? null,
  );

  return useMemo(
    () => ({
      data: stale.data,
      generatedAt: stale.generatedAt,
      isStale: stale.isStale,
      validation: null, // TODO: add validation when schema validation is added
      isLoading: pollingResult.isLoading,
      isFetching: pollingResult.isFetching,
      isError: pollingResult.isError,
      error: pollingResult.error,
      lastSentTime: pollingResult.lastSentTime,
      lastReceiveTime: pollingResult.lastReceiveTime,
    }),
    [pollingResult, stale],
  );
};
